"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_ARROW_UP = exports.KEY_ARROW_DOWN = exports.LIST_ITEM_POSITION_LAST = exports.LIST_ITEM_POSITION_FIRST = void 0;
var LIST_ITEM_POSITION_FIRST = 'first';
exports.LIST_ITEM_POSITION_FIRST = LIST_ITEM_POSITION_FIRST;
var LIST_ITEM_POSITION_LAST = 'last';
exports.LIST_ITEM_POSITION_LAST = LIST_ITEM_POSITION_LAST;
var KEY_ARROW_DOWN = 'ArrowDown';
exports.KEY_ARROW_DOWN = KEY_ARROW_DOWN;
var KEY_ARROW_UP = 'ArrowUp';
exports.KEY_ARROW_UP = KEY_ARROW_UP;